import { useSendCommand } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { ChangeStorymapCustomAiStoryTemplate as ChangeStorymapCustomAiStoryTemplateCommand } from '../../api/commands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeCustomAiStoryTemplate extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeCustomAiStoryTemplate';

    public constructor(public id: string, public name: string, public body: string, public target: number, public isVisibleByDefault: boolean = false) {
        super(ChangeCustomAiStoryTemplate.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeCustomAiStoryTemplate): Promise<boolean> => {
    return await useSendCommand(action, {
        createCommand: () => new ChangeStorymapCustomAiStoryTemplateCommand(action.id, state.id, action.name, action.body, action.target, action.isVisibleByDefault),
    });
};

const reducer = (state: StorymapState, action: ChangeCustomAiStoryTemplate): void => {
    // @ts-ignore
    const template = state.customAiStoryTemplates.find((x) => x.id === action.id);
    template.name = action.name;
    template.body = action.body;
    template.target = action.target;
    template.isVisibleByDefault = action.isVisibleByDefault;

    state.customAiStoryTemplates.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
};

//@ts-ignore
registerMiddleware(ChangeCustomAiStoryTemplate.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeCustomAiStoryTemplate.ACTION_TYPE, reducer);
